export default class GoogleTagAdapter {
  static push(func) {
    window.googletag.cmd.push(function() {
      func();
    });
  }

  static display(divOrSlot) {
    window.googletag.display(divOrSlot);
  }

  static pubads() {
    return window.googletag.pubads();
  }

  static companionAds() {
    return window.googletag.companionAds();
  }

  static enableVideoAds() {
    return GoogleTagAdapter.pubads().enableVideoAds();
  }

  static defineSlot(ad_slot, ad_size, ad_name) {
    if(GoogleTagAdapter.isAdNameDefined(ad_name)) {
      return
    }

    return window.googletag
      .defineSlot(ad_slot, ad_size, ad_name)
      .addService(GoogleTagAdapter.pubads());
  }

  static defineSlotWithCompanionAds(ad_slot, ad_size, ad_name) {
    return window.googletag
      .defineSlot(ad_slot, ad_size, ad_name)
      .addService(GoogleTagAdapter.companionAds())
      .addService(GoogleTagAdapter.pubads());
  }

  static collapseEmptyDivs() {
    GoogleTagAdapter.pubads().collapseEmptyDivs();
  }

  static setTargeting(key, value) {
    GoogleTagAdapter.pubads().setTargeting(key, value);
  }

  static setChildDirectedTreatment(childDirected) {
    GoogleTagAdapter.pubads().setTagForChildDirectedTreatment(childDirected? 1 : 0);
  }

  static refresh(slot) {
    GoogleTagAdapter.pubads().refresh(slot);
  }

  static addEventListener(eventName, func) {
    GoogleTagAdapter.pubads().addEventListener(eventName, func);
  }

  static enableLazyLoad(options) {
    GoogleTagAdapter.pubads().enableLazyLoad(options);
  }

  static setPpid() {
    const visitor_id = window.kmklabs?.gtm?.visitor_id

    if (visitor_id) {
      const ppid = visitor_id.replace(/-/g, "") + "vidio";
      GoogleTagAdapter.pubads().setPublisherProvidedId(ppid);
    }
  }

  static isAdNameDefined(ad_name) {
    if(window.kmklabs?.gpt) {
      return !!Object.keys(window.kmklabs.gpt)
        .filter((slot) => typeof(window.kmklabs.gpt[slot]) === 'object' && Object.prototype.hasOwnProperty.call(window.kmklabs.gpt[slot], 'getSlotElementId'))
        .find((slot) => window.kmklabs.gpt[slot].getSlotElementId() === ad_name);
    }
    return false;
  }
}
